import React from 'react'
import { ImageBannerItemProps } from './types'
import Box from '@material-ui/core/Box'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { CSSProperties } from '@material-ui/styles'
import './imageBanner.scss'

type Props = {
  imageAlignment: number
  isOneSlide?: boolean
  biggestHeadlineHeight?: number
  biggestContentHeight?: number
} & ImageBannerItemProps

const ImageBannerItem = ({
  buttonLink,
  buttonTitle,
  description,
  heading,
  imageUrl,
  subheading,
  imageAlignment,
  isOneSlide,
  altText = '',
  biggestHeadlineHeight,
  biggestContentHeight
}: Props) => {
  const isSmall = useMediaQuery('(max-width: 1140px)')

  const mainContentStyle = {
    height: `${biggestContentHeight}px`,
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'space-between'
  }

  return (
    <Box
      width={isSmall && !isOneSlide ? '326px' : '100%'}
      mr={isSmall && !isOneSlide ? '8px' : ''}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: isSmall
            ? 'column'
            : imageAlignment === 2
            ? 'row-reverse'
            : 'row'
        }}
      >
        <Box style={{ flex: isSmall ? '0 0 100%' : '0 0 50%' }}>
          <img
            src={imageUrl}
            alt={altText ? altText : ''}
            width="100%"
            className="image-banner-item__image"
          />
        </Box>
        <Box
          style={{
            flex: isSmall ? '0 0 100%' : '0 0 50%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            className="mainContent"
            style={
              !isOneSlide && isSmall ? mainContentStyle : ({} as CSSProperties)
            }
            width={isSmall ? '100%' : '459px'}
          >
            <Box>
              <Box
                className="headingContainer"
                height={
                  !isOneSlide && isSmall ? `${biggestHeadlineHeight}px` : ''
                }
              >
                <h2 className="image-banner-item__heading">{heading}</h2>
                <h2 className="image-banner-item__subheading">{subheading}</h2>
              </Box>
              <p className="image-banner-item__description">{description}</p>
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent="left"
            width={isSmall ? '100%' : '459px'}
          >
            <button className="image-banner-item__button">
              <a href={buttonLink}>{buttonTitle}</a>
            </button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
export default ImageBannerItem
